import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import EmployeeDetailControl from '../Employee/EmployeeDetailControl.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RecruitmentDetails = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;


	const { search } = useLocation();
		const searchparams = new URLSearchParams(search);
		const param = searchparams.get("id");


	// alert(param);

const [recruitdet, setRecruitmentDetail] = useState({
	recruit_date: "",
	interview_by: "",
	recruit_by: "",
	first_report:"",
	second_report:"",
	third_report:"",
	
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setRecruitmentDetail({ ...recruitdet, [name]: value });

		
	}


	const [allemployeeval, setallemployeeval]= useState([]);

	const handleAllEmployee = async () => {

		axios.get(API_BASE_URL +'/showallemployee', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		// .then(res1 => console.log(res1.data.user_det))
		.then(res1 => setallemployeeval(res1.data.user_det))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllEmployee();
	  }, []);



	  const [data, setData] = useState([]);

	//   useEffect(() => {
	// 	axios.get(API_BASE_URL + '/fetchprecheck/'+ param, {
	// 		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	// 	})


	// 		.then(res => setData(res.data))
	// 		// .then(res => console.log(res.data))
	// 		.catch(err => console.log(err));
	// }, [])



	useEffect(() => {
		axios.get(API_BASE_URL + '/showrecruitment/'+ param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			 .then(res => setRecruitmentDetail(res.data[0]))
			// .then(res => console.log(res.data[0]))
			.catch(err => console.log(err));
	}, [])



	const handleUpdateRecruitDetailsSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
        // alert(recruitdet.recruit_date);

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addrecruitInfo', { recruit_date: recruitdet.recruit_date,recruit_by:recruitdet.recruit_by,interview_by:recruitdet.interview_by,first_report:recruitdet.first_report,second_report:recruitdet.second_report,third_report:recruitdet.third_report,user_id:param }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};




	return (
		<>


<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3" style={{
                
                backgroundColor:
                    "#fff",
            }}>
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<i className="fa fa-briefcase mr-2" style={{ fontSize: "20px" }} />
												Recruitment Details
											</h3>
										</div>
										<div className="card-body">
                                        <form onSubmit={handleUpdateRecruitDetailsSubmit}> 
												<div class="row">
										
									<div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Recruitement Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="recruit_date" value={recruitdet.recruit_date}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Interviewed By</label>
										<div className="form-group">

										<select className="form-control show-tick required-input required-tooltip" name="interview_by" value={recruitdet.interview_by} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.employee_id} value={option1.employee_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Recruited By </label>

											<select className="form-control show-tick required-input required-tooltip" name="recruit_by" value={recruitdet.recruit_by} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.employee_id} value={option1.employee_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>


                                     <div className="col-md-4 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">First Reporting </label>

											<select className="form-control show-tick required-input required-tooltip" name="first_report" value={recruitdet.first_report} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.employee_id} value={option1.employee_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>

                                     <div className="col-md-4 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Second Reporting </label>

											<select className="form-control show-tick required-input required-tooltip" name="second_report" value={recruitdet.second_report} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.employee_id} value={option1.employee_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>

                                    <div className="col-md-4 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Third Reporting </label>

											<select className="form-control show-tick required-input required-tooltip" name="third_report" value={recruitdet.third_report} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.employee_id} value={option1.employee_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>


									


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>


										



										
										




									</div>
								</div>

							</div>
						</div>
					</div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RecruitmentDetails);